import type { Badge } from '@/types'
import { getLocalizedCountryName } from './localizedContent'
import type { Locale } from './languageStore'
import { t, type TranslationKey } from './i18n'

/**
 * Continent/theme/milestone badges have a fixed id, so their copy is a
 * plain per-id dictionary lookup. Country badges are generated dynamically
 * per country at import time (see COUNTRY_BADGES in data/badges.ts) — there's
 * no per-country dictionary entry to look up, so these are built from a
 * template plus the shared country-name dictionary instead.
 */
export function getLocalizedBadgeName(badge: Badge, locale: Locale): string {
  if (badge.category === 'country') {
    return t('badge.country.name', locale, {
      flag: badge.emoji,
      country: getLocalizedCountryName(badge.country!, locale),
    })
  }
  return t(`badge.${badge.id}.name` as TranslationKey, locale)
}

export function getLocalizedBadgeDescription(badge: Badge, locale: Locale): string {
  if (badge.category === 'country') {
    return t('badge.country.description', locale, { country: getLocalizedCountryName(badge.country!, locale) })
  }
  return t(`badge.${badge.id}.description` as TranslationKey, locale)
}

export function getLocalizedLevelTitle(level: number, locale: Locale): string {
  return t(`level.${level}` as TranslationKey, locale)
}
